export enum EventStatus {
    
    Pending = 0,
    
    Dispatched = 1,
    
    Completed = 2

}

export const EventStatusMetadata = {
    '0': {
        display: 'Pending',
        value: 0,
        class: 'pending-event'
    },
    '1': {
        display: 'Dispatched',
        value: 1,
        class: 'dispatched-event'
    },
    '2': {
        display: 'Completed',
        value: 2,
        class: 'completed-event'
    }
};
